
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EmploymentAgenda.html?raw';
import "../../../moreCore/UI/AgendaView/AgendaView";
import AgendaViewBase from '../../AgendaViewBase/AgendaViewBase';

class EmploymentAgenda extends compose(AgendaViewBase<any>) {
    templateString: any = template;


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupAgendaView(
            null,
            "EmploymentFinder/GetEmploymentAgendaResult",
            null,//lang.hitch(this, this.rowClickFunction),
            null,//lang.hitch(this, this.formatterFunction)
        );

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        
    }
}

export default mdsWidget(EmploymentAgenda);